export const TARIFF_PLANS = {
  advanced: 'advanced',
  plus: 'plus',
  standard: 'standard',
};

export const TARIFF_PLANS_INFO = {
  [TARIFF_PLANS.standard]: {
    label: 'Standard',
    flat_fee: '9%',
    principal: '2%',
  },
  [TARIFF_PLANS.advanced]: {
    label: 'Advanced',
    flat_fee: '6%',
    principal: '8%',
  },
  [TARIFF_PLANS.plus]: {
    label: 'Plus',
    flat_fee: '7.5%',
    principal: '4%',
  },
};

export const LAST_UPDATED = '2025-05-01'
